/* eslint-disable */
import { auth } from '../api/fbConnect'

const fbLogin = {
	actions: {
		signIn({commit}, payload) {
			auth.signInWithEmailAndPassword(payload.email, payload.password)
			.then(e => {
				var tokens = {
					email: e.user.email,
					idToken: e.user.getIdToken()
				}
				commit('loginTokens', tokens)
				localStorage.setItem('token', tokens.idToken)
				this.$store.commit('setLoading', false)
			})
			.catch(error => {
				console.log(error)
			})
		},
		getLogin({commit}) {
			auth.onAuthStateChanged(e => {
				if (e != null) {
					var tokens = {
						email: e.email,
						idToken: e.getIdToken()
					}
					commit('loginTokens', tokens)
					localStorage.setItem('token', tokens.idToken)
				}
			})
		},
		logout({commit}) {
			auth.signOut().then(() => {
				commit('logoutUser')
			})
			.catch(error => {
				console.log(error)
			})
		},
		register({commit}, payload) {
			switch (payload.type) {
				case 'emailAndPassword':
					if (payload.onlyReg){
						auth.createUserWithEmailAndPassword(payload.data.email, payload.data.password)
						.then(e => {
							var tokens = {
								email: e.user.email,
								idToken: e.user.getIdToken()
							}
							commit('loginTokens', tokens)
							localStorage.setItem('token', tokens.idToken)
							commit('setLoading', false)
						})
						.catch( error => {
							console.log(error)
						})
					} else {
						return auth.createUserWithEmailAndPassword(payload.data.email, payload.data.password)
					}
				default:
					return false
			}
		},
		delete({commit}, payload) {
			if(payload.uid) {
				/* user.delete()
				.then(e => {
					console.log(e)
					commit('setLoading', false)
				})
				.catch(error => {
					console.log(error)
				}) */
			}
			/*
			var dataRef = storage.ref();
			var ref = dataRef.child('agendas/'+payload.uid)
			ref.delete()
			.then(e => {
				console.log(e)
			})
			.catch(error => {
				console.log(error)
			})
			*/
		}
	}

}

export default fbLogin
